import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { EPISODE_AORCM_REFERENCE_DATA_URL } from '../../../constants';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getAorcmReferenceData = createAsyncThunk(
  'stop/getAorcmReferenceData',
  async (params) => {
    const config = {
      headers: {
        Authorization: params,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(EPISODE_AORCM_REFERENCE_DATA_URL, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const aorcmReferenceSlice = createSlice({
  name: 'stop/aorcmReference',
  initialState: null,
  reducers: {
    resetAorcmReference: () => null,
  },
  extraReducers: {
    [getAorcmReferenceData.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetActivitiesReference } = aorcmReferenceSlice.actions;

export default aorcmReferenceSlice.reducer;
